import React from '../helpers/react';
import Step from '../components/Step.js';

export const FakeSolution = React.createClass({
    getInitialState: function(){
        return {
            opened: true
        }
    },
    toggle : function(){
        this.setState({
            opened: !this.state.opened
        })
    },
    render : function(){
        let html = '<div>\
            <h1>Header1</h1>\
            <h2>Header2</h2>\
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ac leo lorem. In ornare mattis augue non tristique. Praesent tristique quam augue, eu bibendum nibh bibendum vitae. Aliquam velit nibh, pharetra in mi feugiat, sollicitudin aliquet nisl. Etiam congue nisi sed enim bibendum laoreet. Suspendisse justo neque, finibus molestie posuere vel, laoreet non sem. Aenean finibus arcu nec egestas posuere. Curabitur nec posuere ipsum. Donec volutpat lacinia iaculis. Duis tristique tortor et metus aliquet pretium sed ac lectus. Suspendisse auctor bibendum ligula eget vestibulum.</p>\
            <ul>\
                <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ac leo lorem. In ornare mattis</li>\
                <li>Item 2</li>\
                <li>Item 3</li>\
            </ul>\
            <ol>\
                <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi ac leo lorem. In ornare mattis</li>\
                <li>Item 2</li>\
                <li>Item 3</li>\
            </ol>\
            <table>\
                <tr>\
                    <th>adsasdasdsad</th>\
                    <th></th>\
                    <th>asdasdsa</th>\
                    <th>asdasdasdasdsad</th>\
                </tr>\
                <tr>\
                    <td></td>\
                    <td>asdasdasdsadasd</td>\
                    <td>aaa</td>\
                    <td></td>\
                </tr>\
                <tr>\
                    <td>asdasdasdasd</td>\
                    <td>aaa</td>\
                    <td>asdasdasd</td>\
                    <td>aaaa</td>\
                </tr>\
                <tr>\
                    <td></td>\
                    <td>asdasdasdasdas</td>\
                    <td></td>\
                    <td>aaa</td>\
                </tr>\
            </table>\
        </div>';

        return (
            <section className="problem TBS_PROBLEM">
                <section className="solution TBS_SOLUTION">
                    <header>Step-by-step solution</header>
                    <ol className="steps">
                        <li>
                            <Step
                            index={0}
                            show_comments={false}
                            total={1}
                            toggle={this.toggle}
                            opened={this.state.opened}
                            solution_id={1}
                            user={{}}
                            html = {html}
                            id={1}/>
                        </li>
                    </ol>
                </section>
            </section>
        );
    }
});

export default FakeSolution;


// WEBPACK FOOTER //
// ./src/containers/FakeSolution.js